import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=971d8b7e&scoped=true"
import script from "./countdown.ts?vue&type=script&lang=ts&external"
export * from "./countdown.ts?vue&type=script&lang=ts&external"
import style0 from "./countdown.scss?vue&type=style&index=0&id=971d8b7e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d8b7e",
  null
  
)

export default component.exports